"use client";

import { Modal } from "react-bootstrap";
import { useRef, useEffect, useState } from "react";

interface CustomOfferModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  block: {
    customOptionsForm: string;
  };
}

const CustomOfferModal = (props: CustomOfferModalProps) => {
  const { showModal, setShowModal, block } = props;
  const form = block?.customOptionsForm;
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const formHasMovedRef = useRef(false);
  const formDivRef = useRef<HTMLDivElement>(null);
  const [formId] = useState(
    () => `custom-offer-form-${Math.random().toString(36).substring(2, 9)}`,
  );

  // Watch for form to be populated by HubSpot, move it when ready
  useEffect(() => {
    const customOfferFormDiv = formDivRef.current;

    if (!customOfferFormDiv) return;

    // Set up observer from the start to catch when form initializes
    const observer = new MutationObserver(() => {
      const hasChildren = customOfferFormDiv.children.length > 0;
      const modalBody = modalBodyRef.current;

      // If form has children and modal is open, move them
      if (hasChildren && showModal && !formHasMovedRef.current && modalBody) {
        while (customOfferFormDiv.firstChild) {
          modalBody.appendChild(customOfferFormDiv.firstChild);
        }
        formHasMovedRef.current = true;
      }
    });

    observer.observe(customOfferFormDiv, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [showModal]);

  // Handle moving form when modal opens/closes
  useEffect(() => {
    const customOfferFormDiv = formDivRef.current;
    const modalBody = modalBodyRef.current;

    if (!customOfferFormDiv || !modalBody) return;

    if (showModal) {
      // If form has already been initialized, move children
      if (customOfferFormDiv.children.length > 0 && !formHasMovedRef.current) {
        while (customOfferFormDiv.firstChild) {
          modalBody.appendChild(customOfferFormDiv.firstChild);
        }
        formHasMovedRef.current = true;
      }
    } else {
      // Move children back to formDiv when modal closes
      if (customOfferFormDiv && formHasMovedRef.current) {
        while (modalBody.firstChild) {
          customOfferFormDiv.appendChild(modalBody.firstChild);
        }
        formHasMovedRef.current = false;
      }
    }
  }, [showModal]);

  return (
    <>
      <div
        ref={formDivRef}
        id={formId}
        style={{ display: "none" }}
        suppressHydrationWarning={true}
        dangerouslySetInnerHTML={{
          __html: form || "",
        }}
      />

      <Modal
        show={showModal}
        centered
        onHide={() => setShowModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Egyedi ajánlat kérése</Modal.Title>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef}></Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomOfferModal;
